<template>
  <div ref="promoBarRef">
    <base-ticker
      ref="tickerRef"
      :active="activeIndex"
      :interval="autorotateTime"
      :max="displayedMessages.length"
      @change="handleChange"
    >
      <transition-group name="fade">
        <cms-section
          v-show="displayedMessages.includes(message) && i === activeIndex"
          v-for="(message, i) in messages"
          :key="i"
          class="w-full duration-500 inset-y-0 absolute"
          :section="{ items: [{ ...message, isFullWidth: true }] as Segmentation[], name: 'promo-bar-message' }"
        />
      </transition-group>
    </base-ticker>
  </div>
</template>

<script lang="ts" setup>
import type { BaseTicker } from '#components'
import type { PromoBarContent } from '#types/components/cms/promo-bar'
import type { Segmentation } from '#types/components/cms/segmentation'

export type Props = {
  content: PromoBarContent
}
const { content } = defineProps<Props>()

const { autorotateTime, messages = [] } = content

const { maxPromoMessages } = useAppConfig().components.cms.promoBar
const emptySections = useState<Record<string, boolean>>('emptySections', () => ({}))

const promoBarRef = ref()
const hovered = useElementHover(promoBarRef)
const { focused } = useFocusWithin(promoBarRef)

const activeIndex = ref(0)
const tickerRef = ref<InstanceType<typeof BaseTicker>>()

const displayedMessages = computed(
  () => messages.filter((message) => !emptySections.value[message.id]).slice(0, maxPromoMessages)
)

const handleChange = (current: number) => activeIndex.value = current

watch([focused, hovered], ([focused, hovered]) => {
  if (focused || hovered)
    tickerRef.value?.pause()
  else
    tickerRef.value?.resume()
})
</script>
